import { createSlice } from "@reduxjs/toolkit";

export const brandSlice= createSlice({
    name:"brand",
    initialState:{
        brandList:[]

    },
    reducers:{
        setBrandList:(state,action)=>{
            state.brandList = action.payload;
        }
    }
})

export const {setBrandList} = brandSlice.actions;
export default brandSlice.reducer; 